module.exports = __webpack_public_path__ + "media/images/mvc_logo-fc9064c1d11b7bea88d83d8bb423d76d.png";